// extracted by mini-css-extract-plugin
export default {"container":"ProductPromotionInfo__container___LgEq9","text":"ProductPromotionInfo__text___J4ShN"};